export default __webpack_public_path__ + "static/059-d378f46eddf495d27da5db86d625a20f.jpg";